// extracted by mini-css-extract-plugin
export default {"container":"DateInput_container__qDBmf","label":"DateInput_label__FhAiU","dateInput":"DateInput_dateInput__4NzVu","active":"DateInput_active__8965T"};